// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN RUST INSTEAD.

// @ts-ignore
import { __SPACETIMEDB__, AlgebraicType, ProductType, BuiltinType, ProductTypeElement, DatabaseTable, AlgebraicValue, ReducerArgsAdapter, SumTypeVariant, Serializer, Identity, Address, ReducerEvent, Reducer, SpacetimeDBClient } from "@clockworklabs/spacetimedb-sdk";

export class UpdateElementClipReducer extends Reducer
{
	public static reducerName: string = "UpdateElementClip";
	public static call(_elementId: number, _clip: string) {
		this.getReducer().call(_elementId, _clip);
	}

	public call(_elementId: number, _clip: string) {
		const serializer = this.client.getSerializer();
		let _elementIdType = AlgebraicType.createPrimitiveType(BuiltinType.Type.U32);
		serializer.write(_elementIdType, _elementId);
		let _clipType = AlgebraicType.createPrimitiveType(BuiltinType.Type.String);
		serializer.write(_clipType, _clip);
		this.client.call("UpdateElementClip", serializer);
	}

	public static deserializeArgs(adapter: ReducerArgsAdapter): any[] {
		let elementIdType = AlgebraicType.createPrimitiveType(BuiltinType.Type.U32);
		let elementIdValue = AlgebraicValue.deserialize(elementIdType, adapter.next())
		let elementId = elementIdValue.asNumber();
		let clipType = AlgebraicType.createPrimitiveType(BuiltinType.Type.String);
		let clipValue = AlgebraicValue.deserialize(clipType, adapter.next())
		let clip = clipValue.asString();
		return [elementId, clip];
	}

	public static on(callback: (reducerEvent: ReducerEvent, _elementId: number, _clip: string) => void) {
		this.getReducer().on(callback);
	}
	public on(callback: (reducerEvent: ReducerEvent, _elementId: number, _clip: string) => void)
	{
		this.client.on("reducer:UpdateElementClip", callback);
	}
}


export default UpdateElementClipReducer
